// Hero floating finance card - 3 sliders (price, down payment, term in
// MONTHS) → live monthly. Mirrors the full finance-calculator section.
import { qs, on } from '../lib/dom.js';
import { num, monthlyPayment } from '../lib/format.js';

// Fallback ONLY - the live rate arrives via `data-apr` on the component,
// printed by the server from the `autoplaza_apr` setting. The block right
// below already advertises that setting ("DAE de la X%"), so computing at a
// different hardcoded rate made the widget contradict its own label.
const APR_FALLBACK = 0.079;

export function initHeroFinance() {
  const root = qs('[data-component="hero-finance"]');
  if (!root) return;

  const priceSlider = qs('[data-role="hf-price-slider"]', root);
  const downSlider = qs('[data-role="hf-down-slider"]', root);
  const termSlider = qs('[data-role="hf-term-slider"]', root);
  const priceLabel = qs('[data-role="hf-price"]', root);
  const downLabel = qs('[data-role="hf-down"]', root);
  const termLabel = qs('[data-role="hf-term"]', root);
  const monthly = qs('[data-role="hf-monthly"]', root);
  if (!priceSlider || !termSlider) return;

  // Percentage on the attribute (8.5) -> fraction. 0 is a legitimate value
  // (0% promo), which monthlyPayment() already handles.
  const aprAttr = parseFloat(root.dataset.apr);
  const apr = Number.isFinite(aprAttr) && aprAttr >= 0 ? aprAttr / 100 : APR_FALLBACK;

  // The down-payment slider's range follows the chosen price (capped at
  // 90% of it, on the 500 step) - a fixed 0-60k range would leave most of
  // the track as a dead zone on cheaper cars and let the rate hit 0.
  function syncDownRange() {
    if (!downSlider) return;
    const price = +priceSlider.value;
    const maxDown = Math.max(0, Math.floor((price * 0.9) / 500) * 500);
    downSlider.max = maxDown;
    if (+downSlider.value > maxDown) downSlider.value = maxDown;
  }

  function recalc() {
    syncDownRange();
    const price = +priceSlider.value;
    const down = downSlider ? +downSlider.value : 0;
    const months = +termSlider.value;
    const m = monthlyPayment(Math.max(0, price - down), apr, months);
    if (priceLabel) priceLabel.textContent = num(price);
    if (downLabel) downLabel.textContent = num(down);
    if (termLabel) termLabel.textContent = months;
    if (monthly) monthly.textContent = num(Math.round(m));
  }
  on(priceSlider, 'input', recalc);
  if (downSlider) on(downSlider, 'input', recalc);
  on(termSlider, 'input', recalc);
  recalc();
}
